import { Component, Renderer2 } from '@angular/core';
import { routes } from '../../shared/routes/routes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  standalone: false,
  
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  public routes = routes
   password: boolean[] = [false, false]; // Add more as needed
 
   togglePassword(index: number): void {
     this.password[index] = !this.password[index];
   }
   constructor(
     private router: Router,
     private renderer:Renderer2
   ){}
   navigation(){
     this.router.navigate([routes.index])
   }
   ngOnInit(): void {
     this.renderer.addClass(document.body, 'bg-light-200');
   }
   ngOnDestroy(): void {
     this.renderer.removeClass(document.body, 'bg-light-200');
   }
}
